"use client";

import { Suspense, useEffect } from "react";
import CreateDressPageContent from "@/components/create/CreateDressPageContent";
import { CreatePageLoaderFallback } from "@/components/create/CreatePageLoaderFallback";
import "@/components/create/agent/designer-workspace.css";

export default function CreateDressPageClient() {
  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    const previousRootBackground = root.getAttribute("data-app-background");
    const previousBodyBackground = body.getAttribute("data-app-background");

    root.setAttribute("data-app-background", "create");
    body.setAttribute("data-app-background", "create");

    return () => {
      if (previousRootBackground) {
        root.setAttribute("data-app-background", previousRootBackground);
      } else {
        root.removeAttribute("data-app-background");
      }

      if (previousBodyBackground) {
        body.setAttribute("data-app-background", previousBodyBackground);
      } else {
        body.removeAttribute("data-app-background");
      }
    };
  }, []);

  return (
    <div
      data-create-page-shell
      data-app-background="create"
      className="app-route-background fixed inset-0 z-0 min-h-dvh"
    >
      <div className="flex h-full min-h-0 flex-col overflow-hidden">
        {/* Suspense is not a flex box; this wrapper lets the page fill height below padding-top. */}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <Suspense fallback={<CreatePageLoaderFallback />}>
            <CreateDressPageContent />
          </Suspense>
        </div>
      </div>
    </div>
  );
}
